exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".thumb {\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n  }\n  \n  .thumb li {\n    width: 193px;\n  }\n  \n  .thumb li ~ li {\n    margin-left: 20px;\n  }\n  \n  .thumb .thumbCaption {\n    padding: 10px 0;\n  }\n  \n  .overlay {\n    position: relative;\n  }\n  \n  .overlay .thumbnail {\n    display: block;\n  }\n  \n  .overlay .time {\n    position: absolute; z-index: 2;\n    right: 3px; bottom: 3px;\n    padding: 2px 5px;\n    background-color: rgba(0, 0, 0, 0.6);\n    color: white;\n  }\n  \n  .overlay .playWrapper {\n    opacity: 0;\n    position: absolute; z-index: 1;\n    top: 0;\n    width: 286px; height: 100%;\n    background: rgba(0,0,0,0.6) url(\"/assets/images/generals/playButton.png\") no-repeat scroll center center / 50px 50px;\n  }\n  \n  .playWrapper .playBtn {\n    position: absolute; z-index: 2;\n    width: 50px; height: 50px;\n    left: 0; right: 0; top: 0; bottom: 0; margin: auto; /* center */\n  }\n  \n  .thumb .overlay:hover .playWrapper {\n    opacity: 1;\n  }\n  ", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/tutorial-list/tutorial-list.component.css
// module id = 452
// module chunks = 0